import React from "react";
import { useEffect, useState } from "react";
import paymentSuccess from "../../images/paymentSuccess.svg";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";

const PaymentSuccess = () => {


  const [paymentId, setPaymentId] = useState("");
  const [signature, setSignature] = useState("");
  const [formattedDateTime, setFormattedDateTime] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get("razorpay_payment_id");
    const sig = urlParams.get("razorpay_signature");
    const now = new Date();

    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    const formatted = now.toLocaleString("en-IN", options).replace(",", " |");
    setFormattedDateTime(formatted);





    setPaymentId(pid);
    setSignature(sig);
  }, []);


  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div
          style={{ overflowX: "hidden" }}
          className="container-fluid container-viewLeadDetails"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
            className="country-header"
          ></div>

          <div>
            <div className="container-fluid px-3 py-2" style={{ width: "59%" }}>
              <div
                className="mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img src={paymentSuccess} alt="paymentSuccess" style={{ marginTop: "18px", width: "39%" }} />
                <h1 style={{ fontWeight: "600", padding: "15px" }}>Payment Successful!</h1>
                <p style={{ fontSize: "13px", fontStyle: "italic", fontWeight: "500" }}>
                  Thank you for your payment. Your transaction has been successfully processed.
                </p>

                <p style={{ fontSize: "10px" }}>Payment ID : {paymentId} Date & Time : {formattedDateTime}</p>
                <p style={{ fontSize: "10px" }}>Signature : {signature}</p>
              </div>

              <div className="expenseList"></div>
            </div>
          </div>
          {/* ------------------------customer deatil--------------------- */}
        </div>
      </div>
    </div>
  )
}
export default PaymentSuccess